<template>
  <div class="contact">
    <ul class="contact-list clearflx">
      <li class="contact-list-item" v-for="(item,index) in list" :key="index">

        <img class="contact-list-item-icon" v-if="item.type === 1" src="../../assets/img/icon_phone1.png" alt="广物电话">
        <img class="contact-list-item-icon" v-else-if="item.type === 2" src="../../assets/img/icon_address.png" alt="地址">

        <p class="contact-list-item-phone">{{item.title}}</p>
        <!-- 每一项 -->
        <div class="contact-list-item-content clearflx" v-for="(item,index) in item.partList" :key="index">
          <div class="contact-list-item-content-title">{{item.part}}：</div>
          <div class="contact-list-item-content-details">{{item.content}}</div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import {selectPartList} from '../../api/part/selectPartList'
  export default {
    data() {
      return {
        list: [],
        type: '', // 0总部 2分部
      }
    },
    methods: {
      getContactList() {
        let {name} = this.$route;
        switch (name) {
          case 'headquarters':
            this.type = 1;
            break;
          case 'branch':
            this.type = 2;
            break;
        }

        selectPartList({type:this.type}).then(res => {
          this.list = res.data;
        }).catch(err => {
          this.$message.error(err.message);
        })
      }
    },
    created() {
      this.getContactList()
    },
    watch: {
      $route() {
        this.getContactList()
      }
    }
  }
</script>

<style lang="scss" scoped>
@import '../../assets/css/register.scss';
@import '../../assets/css/base.scss';
  .contact {
    &-list {
      &-item {
        display: inline-block;
        width: 50%;
        text-align: center;
        padding: 60px 20px 40px;
        box-sizing: border-box;
        border: 1px dashed rgba(0,0,0,.0);
        vertical-align: top;
        min-height: 330px;
        &:nth-child(4n+1) {
          border-right: 1px dashed #aaa;
          border-bottom: 1px dashed #aaa;
        }
        &:nth-child(4n+2) {
          border-bottom: 1px dashed #aaa;
        }
        &:nth-child(4n+3) {
          border-right: 1px dashed #aaa;
        }
        &:nth-child(4n+5) {
          border-top: 1px dashed #aaa;
        }
        &:nth-child(4n+6) {
          border-top: 1px dashed #aaa;
        }
        &:nth-last-child(-n+2) {
          border-bottom: none;
        }
        &-icon {
          width: 36px;
        }
        &-phone {
          font-weight: 700;
          color: #111;
          padding: 10px 0 20px;
        }
        &-content {
          text-align: left;
          padding-bottom: 5px;
          &-title {
            width: 100px;
            float: left;
            text-align: right;
            display: inline-block;
            font-weight: 700;
          }
          &-details {
            padding-left: 100px;;
          }
        }
      }
    }
  }

  @media screen and (max-width: 768px){
    .contact {
      &-list {
        &-item {
          padding: 20px 10px 10px;
          min-height: 350px;
          overflow: auto;
          &-content {
            &-title {
              float: none;
              text-align: left;
            }
            &-details {
              padding: 0;
            }
          }
        }
      }
    }
  }
</style>